<div class="db-create-options">
  <div class="db-create-options-wrap">
    <div *ngIf="!loading && !(ongoingActivity$ | async)" class="db-create-options-form-wrap">
      <form (ngSubmit)="submit()" *ngIf="!loadingContent" [formGroup]="websiteCreateForm">
        <div class="db-create-options-wrap-title" [innerHTML]="headerTitle" *ngIf="showTitle"></div>
        <div class="db-create-options-wrap-desc" [innerHTML]="'text_createWebsiteOptionsStepDesc' | dbText" *ngIf="showTitle"></div>
        <div class="db-create-options-wrap-body">
          <div class="db-create-options-wrap-body-item">
            <div class="ds-input-wrap">
              <span class="ds-input-label">{{'text_regionDescription' | dbText}}</span>
              <ds-dropdown [dsDropdownOptions]="regionOptions" [formControl]="region" [value]="region?.value"
                           [dsDropdownDisabled]="userSubscription?.type === UserSubscriptionCategory.DedicatedVM">
              </ds-dropdown>
            </div>
          </div>
          <div class="db-create-options-wrap-body-item">
            <div class="ds-input-wrap">
              <span class="ds-input-label">Site Title</span>
              <input type="text" class="ds-input" [placeholder]="'text_myWebsite' | dbText" formControlName="siteTitle">
            </div>
          </div>
        </div>
        <div class="db-create-options-wrap-footer">
          <button class="ds-btn-black ds-btn-l" (click)="submit()" [ngClass]="{'ds-btn-disabled': loadingContent || !websiteCreateForm.valid || (showDomainInput === '' && desiredDomainName === '')}">
            <span>Create Website</span></button>
        </div>
      </form>

    </div>
    <div class="db-create-options-loading-wrap" *ngIf="loading || (ongoingActivity$ | async)">
      <db-website-install-loading-dialog
        [step3]="step3" [insidePageStatic]="true" [ngClass]="{'hidden':!loading && !(ongoingActivity$ | async)}">
      </db-website-install-loading-dialog>
    </div>
  </div>
</div>
